import { Select } from "chakra-react-select";
import { Text } from "@chakra-ui/react";
import React, { forwardRef } from "react";
/**
 * options [{label: string, value: string, colorScheme:string, variant}]
 * value: options
 * onChange: ([{value, label}]) => void
 */
const MultiSelect = ({ options, isMulti = true, value, onChange, isReadOnly, chakraStyles: externalStyles, ...props }) => {
  const optionStyle = (provided, state) => ({
    // is this applied??
    ...provided,
    bg: "transparent",
    color: state.isFocused ? "darkTeal" : "gray.600",
    fontWeight: state.isFocused ? "bold" : "normal",
  });
  const baseStyles = {
    dropdownIndicator: (provided, state) => ({
      ...provided,
      bg: "transparent",
      px: 2,
      cursor: "inherit",
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: "none",
    }),
    option: optionStyle,
    selectedOptionStyle: optionStyle,
  };
  const customStyles = externalStyles
    ? Object.keys(externalStyles).reduce((merged, key) => {
        merged[key] = (provided, state) => {
          const base = baseStyles[key] ? baseStyles[key](provided, state) : provided;
          return externalStyles[key](base, state);
        };
        return merged;
      }, { ...baseStyles })
    : baseStyles;
  if (isReadOnly) {
    const svalue = value ? (Array.isArray(value) ? value.map((v) => v.label || v).join(", ") : value.label) : "";
    return <Text>{svalue}</Text>;
  }
  // Handle issue: If the select is narrow, eg in a table, then the selected option can be displayed badly as a column of letters
  if (value && !Array.isArray(value)) value = [value];
  const toMinWidth = (label) => {
    if (typeof label !== "string") return null;
    if (label.length < 5) return null;
    return Math.min(label.length * 8, 200) + "px";
  };
  const valueWithStyle = value?.map((v) => ({
    ...v,
    label: <div style={{ minWidth: toMinWidth(v.label) }}>{v.label || v}</div>,
  }));

  // Strip JSX labels injected above before handing values back to consumers.
  // Otherwise React elements leak into form/state and break deep-clone/serialize paths.
  const rehydrate = (v) => {
    if (!v) return v;
    if (typeof v.label === "string" || typeof v.label === "number") return v;
    const original = options?.find((o) => o.value === v.value);
    if (original) return original;
    return { ...v, label: v.value != null ? String(v.value) : "" };
  };
  const handleChange = onChange
    ? (newValue, actionMeta) => {
      if (Array.isArray(newValue)) onChange(newValue.map(rehydrate), actionMeta);
      else onChange(rehydrate(newValue), actionMeta);
    }
    : onChange;

  return (
    <Select
      options={options}
      value={valueWithStyle}
      onChange={handleChange}
      isReadOnly={isReadOnly}
      {...props}
      isMulti={isMulti}
      chakraStyles={customStyles}
    />
  );
};
//
// const fowardRefMultiSelect = React.forwardRef(MultiSelect);
// fowardRefMultiSelect.displayName = "MultiSelect"; // for easier debugging
// export default fowardRefMultiSelect;

export default MultiSelect;
